import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { InvoiceLinks } from "@/components/InvoiceUploader";

const inr = (n) => `₹${Number(n || 0).toLocaleString("en-IN", { maximumFractionDigits: 2 })}`;

export default function SelfDisbursed() {
  const [month, setMonth] = useState("all");
  const [data, setData] = useState(null);
  useEffect(() => {
    api.get("/reports/self-disbursed", { params: month === "all" ? {} : { month } }).then(r => setData(r.data)).catch(() => setData({ rows: [], months: [], total: 0 }));
  }, [month]);
  return (
    <div className="p-6 lg:p-8 space-y-4" data-testid="self-disbursed-page">
      <div>
        <div className="text-xs uppercase tracking-widest text-slate-500 font-medium">Reports · Super Admin</div>
        <h1 className="font-display text-3xl font-extrabold mt-1">Self-disbursed payments</h1>
        <p className="text-sm text-slate-500 mt-1">Advances, reimbursements and vendor bills an Accounts user paid to themselves, after your Final approval.</p>
      </div>
      <div className="flex items-center gap-3">
        <Select value={month} onValueChange={setMonth}>
          <SelectTrigger className="w-44" data-testid="self-disb-month"><SelectValue /></SelectTrigger>
          <SelectContent>
            <SelectItem value="all">All months</SelectItem>
            {(data?.months || []).map(m => <SelectItem key={m} value={m}>{m}</SelectItem>)}
          </SelectContent>
        </Select>
        <div className="text-sm" data-testid="self-disb-total">{data?.rows.length || 0} payments · <span className="font-mono font-semibold">{inr(data?.total)}</span></div>
      </div>
      <Card><CardContent className="p-0 overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="text-xs uppercase text-slate-500 bg-slate-50"><tr className="border-b">
            {["Type", "Reference", "Paid to (self)", "Date", "Amount", "Mode", "UTR", "Paid from", "Proof"].map(h => <th key={h} className="text-left px-3 py-2">{h}</th>)}
          </tr></thead>
          <tbody>
            {data && !data.rows.length && <tr><td colSpan={9} className="text-center text-slate-500 py-6" data-testid="self-disb-empty">No self-disbursed payments.</td></tr>}
            {(data?.rows || []).map(r => (
              <tr key={r.id} className="border-b border-slate-100" data-testid={`self-disb-${r.ref}`}>
                <td className="px-3 py-2">{r.kind}</td><td className="px-3 py-2 font-mono text-xs"><a className="underline" href={r.link}>{r.ref}</a></td>
                <td className="px-3 py-2">{r.requester_name}</td><td className="px-3 py-2 font-mono text-xs">{r.pay_date}</td>
                <td className="px-3 py-2 font-mono">{inr(r.amount)}</td><td className="px-3 py-2">{r.mode || "—"}</td>
                <td className="px-3 py-2 font-mono text-xs">{r.utr}</td><td className="px-3 py-2 text-xs">{r.paid_from || "—"}</td>
                <td className="px-3 py-2">{r.proof_file_id ? <InvoiceLinks fileIds={[r.proof_file_id]} compact /> : "—"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </CardContent></Card>
    </div>
  );
}
